export { default as MailIcon } from './MailIcon';
